"use strict"
const Duplex = require('stream').Duplex
const inherits = require('util').inherits

function WebsocketJsonStream (ws) {
  if (!(this instanceof WebsocketJsonStream)) {
    return new WebsocketJsonStream(ws)
  }
  Duplex.call(this, {objectMode: true})
  this._boundOnMessage = this.onMessage.bind(this)
  this._boundSendBufferedMessage = this.sendBufferedMessage.bind(this)
  this.ws = null
  this.bufferedMessage = null
  this.bufferedNext = null
  if (ws) {
    this.setWs(ws)
  }
}
inherits(WebsocketJsonStream, Duplex)

const proto = WebsocketJsonStream.prototype

//no back pressure by default, all messages from server are handled by proto.onMessage (listener defined in proto.setWs)
WebsocketJsonStream.prototype._read = function () {}

//send json data to server
proto._write = function (data, enc, next) {
  let string
  try {
    string = JSON.stringify(data)
  } catch (e) {
    this.emit("encode_warning", {exception: e, data: data, msg: "Error encoding JSON"})
  }
  if (string == null) { return next() }

  const ws = this.ws
  if (ws && ws.readyState === ws.OPEN) {
    ws.send(string)
    return next()
  }
  //wait for ws to open before trying to send data (eventListener defined in proto.setWs)
  this.bufferedMessage = string
  this.bufferedNext = next
}

proto.onMessage = function (data) {
  if (global.WebSocket && data.target instanceof global.WebSocket) {
    //we are in the browser
    data = data.data
  }
  let obj
  try {
    obj = JSON.parse(data.toString())
  } catch (e) {
    this.emit("decode_warning", {exception: e, data: data, msg: "Error decoding JSON"})
  }
  if (obj != null) {
    this.push(obj)
  }
}

proto.setWs = function (ws) {
  const boundOnMessage = this._boundOnMessage
  const boundSendBufferedMessage = this._boundSendBufferedMessage
  if (this.ws) {
    this.ws.removeListener('message', boundOnMessage)
    this.ws.removeListener('open', boundSendBufferedMessage)
  }
  this.ws = ws
  ws.on('message', boundOnMessage)
  this.sendBufferedMessage()
  ws.once('open', boundSendBufferedMessage)
  ws.once('close', function () {
    ws.removeListener('message', boundOnMessage)
    ws.removeListener('open', boundSendBufferedMessage)
  })
}

proto.sendBufferedMessage = function () {
  const message = this.bufferedMessage
  const next = this.bufferedNext
  const ws = this.ws
  if (!message || !next || !ws || (ws.readyState !== ws.OPEN)) {
    return
  }
  this.bufferedMessage = null
  this.bufferedNext = null
  ws.send(message)
  next()
}

module.exports = WebsocketJsonStream
